import tw from 'twin.macro';

const Badge = tw.div`min-w-[20px] min-h-[20px] flex justify-center items-center rounded-[3px] bg-sec-1 text-accent-1 text-[11px] font-medium`;

export const TIER_MAPPER = {
  [1]: 'I',
  [2]: 'II',
  [3]: 'III',
  [4]: 'IV',
};

export const ContextualTierBadge = ({ tier }: { tier: number }) => {
  if (!tier || !TIER_MAPPER[tier as keyof typeof TIER_MAPPER]) return null;

  return <Badge>{TIER_MAPPER[tier as keyof typeof TIER_MAPPER]}</Badge>;
};
